import { Model, RailsFormat } from "./model"
import { Day } from "./day"
import { Term } from "./term"
import { Campus } from "./campus"
import { Course } from "./course"
import { PublicHoliday } from "./public-holiday"
import { DiscountType } from "./discount-type";

export class Constants extends Model {

  constructor(
    public publicHolidays: PublicHoliday[] = [],
    public days: Day[] = [],
    public terms: Term[] = [],
    public campuses: Campus[] = [],
    public courses: Course[] = [],
    public discountTypes: DiscountType[] = [],
  ) { super() }

  static clone(obj: any) {
    const constants: Constants = new this()

    if (obj.publicHolidays && obj.publicHolidays.length > 0) {
      obj.publicHolidays.forEach((ph: any) => {
        constants.publicHolidays.push(PublicHoliday.clone(ph))
      })
    }

    if (obj.days && obj.days.length > 0) {
      obj.days.forEach((d: any) => {
        constants.days.push(Day.clone(d))
      })
    }

    if (obj.terms && obj.terms.length > 0) {
      obj.terms.forEach((t: any) => {
        constants.terms.push(Term.clone(t))
      })
    }

    if (obj.campuses && obj.campuses.length > 0) {
      obj.campuses.forEach((c: any) => {
        constants.campuses.push(Campus.clone(c))
      })
    }

    if (obj.courses && obj.courses.length > 0) {
      obj.courses.forEach((c: any) => {
        constants.courses.push(Course.clone(c))
      })
    }

    if (obj.discountTypes && obj.discountTypes.length > 0) {
      obj.discountTypes.forEach((dt: any) => {
        constants.discountTypes.push(DiscountType.clone(dt))
      })
    }

    return constants
  }

}




// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/models/constants.ts